import { createFileRoute } from '@tanstack/react-router';
import TransfersLayout from './-layouts/transfers-layout';

export const Route = createFileRoute('/_authenticated/transfers')({
  component: TransfersLayout,
});
